module.exports = __webpack_public_path__ + "static/media/background.1c66223d.jpg";